import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { PropertiesService } from '@core/services/properties.service';
import { OrganizationService } from '@core/services/organization.service';

import {
  fetchOrganizationPropertiesAction,
  fetchOrganizationPropertiesActionSuccess,
  fetchOrganizationPropertiesActionFailure,
  getOrganizationByShortNameAction,
  getOrganizationByShortNameActionSuccess,
  getOrganizationByShortNameActionFailure,
} from './organization.actions';

@Injectable()
export class OrganizationEffects {
  constructor(
    private actions$: Actions,
    private propertiesService: PropertiesService,
    private toastr: ToastrService,
    private organizationService: OrganizationService
  ) {}

  fetchOrganizationProperties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchOrganizationPropertiesAction),
      switchMap((query) =>
        this.propertiesService.fetchProperties(query).pipe(
          map((res) => {
            if (res?.listValidProperties) {
              return fetchOrganizationPropertiesActionSuccess(
                res?.listValidProperties
              );
            } else {
              throw Error('No properties found');
            }
          }),
          catchError((error) => {
            this.toastr.error('Failed to fetch organization properties.');
            return [fetchOrganizationPropertiesActionFailure()];
          })
        )
      )
    )
  );

  getOrganizationByShortName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getOrganizationByShortNameAction),
      switchMap((action) =>
        this.organizationService
          .getOrganizationByShortName({
            shortName: action.shortName,
            campaignName: action.campaignName,
            refCode: action.refCode,
          })
          .pipe(
            map((res) => {
              if (res?.getOrganizationByShortName) {
                return getOrganizationByShortNameActionSuccess({
                  organization: res?.getOrganizationByShortName,
                });
              } else {
                throw Error('No organization found');
              }
            }),
            catchError((error) => {
              this.toastr.error('Failed to fetch organization.');
              return [getOrganizationByShortNameActionFailure()];
            })
          )
      )
    )
  );
}
